import { type CalculatePriceCheckoutQuery } from 'types/graphql-generated'

type DiscountItemType =
  CalculatePriceCheckoutQuery['calculatePriceCheckout']['discountItems'][number]['itemUnitDiscount']

interface FindDiscountProps {
  id: number
  discountItems?: CalculatePriceCheckoutQuery['calculatePriceCheckout']['discountItems']
}

export const findDiscount = ({
  id,
  discountItems,
}: FindDiscountProps): DiscountItemType | undefined => {
  const discountItem = discountItems?.find((item) => item.itemId === id)
  return discountItem?.itemUnitDiscount
}
